import { render, staticRenderFns } from "./milkmaintance.vue?vue&type=template&id=299df717&"
import script from "./milkmaintance.vue?vue&type=script&lang=js&"
export * from "./milkmaintance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports